module.exports = "<div ui-view></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/deviceconfigs/deviceconfigs.html
// module id = 540
// module chunks = 0